import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag, Radio } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import auth from "../../../common/utility/auth";

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    {/*           <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idCliente ?
                                    { key: this.props.filter.idCliente } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por cliente" />}
                            onChange={(option) => this.props.onChange("idCliente", option.key)} //STATE PROPERTY
                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.clientes.map(item => ( //STATE DATA
                                item.flagClienteBoleta ?
                                    null :
                                    <Select.Option value={item.id} key={item.id}> <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>

                            ))}
                        </Select>
                    </Col> */}
                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.cliente}
                            onChange={(e) => this.props.onChange("cliente", e.target.value)}
                            placeholder="Filtrar por cliente, Ruc"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idMotivo ?
                                    { key: this.props.filter.idMotivo } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Motivo" />}
                            onChange={(option) => this.props.onChange("idMotivo", option.key, option, 'motivo')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.motivo.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstado ?
                                    { key: this.props.filter.idEstado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                            onChange={(option) => this.props.onChange("idEstado", option.key, option, 'estado')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.estado.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idTipo ?
                                    { key: this.props.filter.idTipo } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Tipo" />}
                            onChange={(option) => this.props.onChange("idTipo", option.key, option, 'tipo')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.modalidad.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </Col>

                    {this.props.filter.tipoReporte == 2 ?
                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.codigoNombre}
                                onChange={(e) => this.props.onChange("codigoNombre", e.target.value)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar por codigo Nombre producto"
                                autoComplete="off"
                            />
                        </Col> : null
                    }

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>

            
                </Row>
            </div>
        );
    }
}

export default Filters;